import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";
// src/anatomy.ts
function anatomy(name) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
  }
  function parts() {
    assert();
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var part = _values[_i];
      ;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function extend() {
    for (var _len2 = arguments.length, parts2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parts2[_key2] = arguments[_key2];
    }
    for (var _i2 = 0, _parts = parts2; _i2 < _parts.length; _i2++) {
      var part = _parts[_i2];
      if (part in map) continue;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function selectors() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        part = _ref2[1];
      return [key, part.selector];
    }));
    return value;
  }
  function classnames() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        part = _ref4[1];
      return [key, part.className];
    }));
    return value;
  }
  function toPart(part) {
    var el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    var attr = el.filter(Boolean).join("__");
    var className = "chakra-".concat(attr);
    var partObj = {
      className: className,
      selector: ".".concat(className),
      toString: function toString() {
        return part;
      }
    };
    return partObj;
  }
  var __type = {};
  return {
    parts: parts,
    toPart: toPart,
    extend: extend,
    selectors: selectors,
    classnames: classnames,
    get keys() {
      return Object.keys(map);
    },
    __type: __type
  };
}
export { anatomy };